import bgMain from '@/assets/images/bg_main.png'
import type { ReactNode } from 'react'
import styles from './AuthLayout.module.css'

interface AuthLayoutProps {
  children: ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div
      className={styles.rootContainer}
      style={{
        backgroundImage: `url(${bgMain})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left center',
        backgroundSize: 'contain',
      }}
    >
      <div className={styles.mainContainer}>{children}</div>
    </div>
  )
}
